/**
 * Authentication utility functions
 */

/**
 * Get the API URL by appending path to base URL
 * @param {string} baseUrl - Base URL from environment
 * @param {string} path - API path to append
 * @returns {string} Full API URL
 */
export function getAPIUrl(baseUrl, path) {
  return baseUrl + path;
}

/**
 * Get the authentication token from localStorage
 * @returns {string} Authorization token string
 */
export function getAuthToken() {
  return "Token " + localStorage.getItem("eventGraphiaToken");
}

/**
 * Whether a token is stored. getAuthToken() can't tell: it returns
 * "Token null" when there is none.
 * @returns {boolean}
 */
export function hasAuthToken() {
  return Boolean(localStorage.getItem("eventGraphiaToken"));
}

/**
 * Redirect to login page
 * @param {string} baseUrl - Base URL for login page
 * @param {string} data - Optional data to pass
 * @param {string} state - Optional state to pass
 * @param {Function} getAllUrlParams - Function to get all URL params
 */
export function getLoginPage(baseUrl, data, state, getAllUrlParams) {
  // data should be in stringified form
  // state should be in stringified form
  var url = baseUrl + "/login";
  var next = {};
  var url_data = {};
  var curr_url_data = getAllUrlParams(window.location.href);
  if (data) {
    url_data["data"] = data;
  }
  if (state) {
    url_data["state"] = state;
  }
  url_data = Object.assign({}, url_data, curr_url_data);
  next["next_url"] = window.location.origin + window.location.pathname;
  next["url_data"] = url_data;
  url += "?next=" + JSON.stringify(next);
  // replace, not assign: the page we are leaving is either unauthenticated or
  // just logged out, so it must not stay in the history for back to land on
  window.location.replace(url);
}

